export class WebhooksController {
    constructor($scope, JFrogGridFactory, JFrogModal, WebhooksDao,$rootScope) {
        this.$scope = $scope;
        this.jfrogGridFactory = JFrogGridFactory;
        this.modal = JFrogModal;
        this.webhooksDao = WebhooksDao;

        $scope.$parent.Settings.showButtons = false;
        $scope.$parent.Settings.currentSubController = this;

        $rootScope.h1Header='Webhooks';
        this._createGrid();
        this._getWebhooks();
        $scope.$on('$destroy', () => {
            $rootScope.h1Header='';
        })
    }

    _createGrid() {
        this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getColumns())
            .setButtons(this._getActions())
    }

    _getWebhooks() {
        this.webhooksDao.get().$promise.then((data)=>{
            this.gridOptions.setGridData(data);
        })
    }

    deleteWebhook(row) {
        this.modal.confirm(`Are you sure you want to delete webhook "${row.name}"?`)
            .then(() => {
                this.webhooksDao.delete({name: row.name}).$promise.then((response)=>{
                    this._getWebhooks();
                })
            });
    }

    _getColumns() {
        return [
            {
                name: 'Name',
                displayName: 'Name',
                field: "name",
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="settings.webhooks.edit({webhookName: row.entity.name})"><a href="">{{row.entity.name}}</a></div>',
                width: '25%'
            },
            {
                name: 'URL',
                displayName: 'URL',
                field: "url",
                width: '45%'
            },
            {
                name: 'Description',
                displayName: 'Description',
                field: "description",
                width: '30%'
            }
        ]
    }

    _getActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteWebhook(row)
            }

        ];
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/webhooks/webhooks.controller.js